/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'window',
    'jquery',
    'pip-events',
    'mustache'
  ],
  function (
    window,
    $,
    pipEvents,
    Mustache
  ) {

    var model = {
      hasInit: false,
      data: {
        fitRating: 0
      },
      setRatingFromDOM: function setRatingFromDOM() {
        var altProp =  $(view.selectors.fitRating).prop('alt');
        if (altProp) {
          var rating = parseFloat(altProp.split(' out of ')[0]);
          if (!isNaN(rating)) {
            model.data.fitRating = Math.round(rating);
          }
        }
      }
    }

    var view = {
      selectors: {
        fitRating: '#customer_reviews .BVRRSummaryPrimaryContentWrapper .BVRRRating.BVRRRatingFit_22 img',
        buyBox: '.super-sku__inline'
      },
      templates:{
        fitRating: $('#ssku__workwear-fit-rating').text()
      },
      render: {
        fitRating: function fitRatingUI() {
          return Mustache.render(view.templates.fitRating, viewModel.ratingsObj);
        }
      },
      initView: function initView() {
        $(view.selectors.buyBox).append( view.render.fitRating() );
      }
    }

    var viewModel = {
      fitRating: 0,
      labelText: 'Customers say it fits',
      descriptors: ['very small','slightly small','just right','slightly large','very large'],
      ratingsObj: {
        activeLabel: '',
        ratings: [
          { rating: 1, active: false },
          { rating: 2, active: false },
          { rating: 3, active: false },
          { rating: 4, active: false },
          { rating: 5, active: false }
        ]
      },
      set:{
        fitRating: function fitRating(fitRating){
          if(fitRating && !isNaN(fitRating) && fitRating > 0 && fitRating <= 5) {
            viewModel.ratingsObj.ratings[(fitRating - 1)].active = true;
            viewModel.fitRating = fitRating;
          }
        },
        activeLabel: function activeLabel(fitRating){
          viewModel.ratingsObj.activeLabel = viewModel.labelText +' '+ viewModel.descriptors[(fitRating - 1)];
        }
      },
      init: function initViewModel(){
        viewModel.set.fitRating(model.data.fitRating);
        viewModel.set.activeLabel(model.data.fitRating);
      }
    }

    return {
      init: function () {
        $(window.document).off('.workwear-bazaarVoiceRatingsReviewsLoaded');
        pipEvents.bazaarVoice.bazaarVoiceRatingsReviewLoaded.on('.workwear-bazaarVoiceRatingsReviewsLoaded', function () {
          model.setRatingFromDOM();
          if (model.data.fitRating) {
            viewModel.init();
            view.initView();
          }
        });
      },
      model: model,
      viewModel: viewModel,
      view: view
    }

  });

}.call(window));